module.exports = __webpack_public_path__ + "img/coupon-tag-close.4faec259.png";